import styled from "styled-components";
export const Container = styled.div<{isAllowMobile?: boolean}>`
  max-width: 1142px;
  width: 90%;
  margin: 0 auto;
  font-size: 0.875rem;
  // color: rgb(43, 43, 43);
  color: #333333;

  ${({isAllowMobile = true}) =>
    isAllowMobile &&
    `
    @media (max-width: 768px) {
      padding-top: 10px;
      font-size: 0.75rem;
      h2 {
        font-size: 0.75rem !important;
      }
      .roll-num {
        font-size: 0.75rem !important;
      }

      .year {
        display: none;
      }
    }
  `}

  .wrap-1 {
    margin-top: 20px;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    &-left {
      width: calc(75% - 10px);
    }

    &-right {
      width: calc(25% - 10px);
    }

    ${({isAllowMobile = true}) =>
      isAllowMobile &&
      `
      @media (max-width: 768px) {
        &-left {
          width: 100% !important;
        }
        &-right {
          width: 100% !important;
        }
      }
    `}
  }

  .wrap-2 {
    ${({isAllowMobile = true}) =>
      isAllowMobile &&
      `
      @media (max-width: 768px) {
        &-left {
          width: 100% !important;
        }
        &-right {
          width: 100% !important;
          margin-top: 0 !important;
        }
      }
    `}

    &-left {
      width: 50%;
      margin-top: 20px;
    }
    &-right {
      width: 50%;
      margin-top: 20px;
    }
  }

  .wrap-3 {
    margin-top: 20px;
  }
`;
